import * as api from "../generated-api";
import { apiCall } from "../common";
import axios from "axios";
import { processUnexpectedError } from "../errors";
import { getBaseUrl } from "../../helpers/utils";

export const getPersonsByOrganizationSearch = (
  orgId: number,
  searchString: string,
  successCallback?: (persons: api.Person[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Person[]>(
    () => {
      return api.getPersonsByOrganization(orgId, { search: searchString });
    },
    successCallback,
    errorCallback
  );
};

export const sendInvitation = (
  personId: number,
  successCallback?: (person: api.Person) => void,
  errorCallback?: (error: Error) => void
) => {
  axios
    .post(
      "/send-person-invitation",
      { person_id: personId },
      { baseURL: getBaseUrl() }
    )
    .then((response) => {
      const oldSchoolUser = response.data.user;
      const person: api.Person = {
        id: oldSchoolUser.person.id,
        createdAt: oldSchoolUser.person.created_at,
        updatedAt: oldSchoolUser.person.updatedAt,
        email: oldSchoolUser.person.email,
        firstName: oldSchoolUser.person.first_name,
        lastName: oldSchoolUser.person.last_name,
        user: {
          id: oldSchoolUser.id,
          createdAt: oldSchoolUser.created_at,
          updatedAt: oldSchoolUser.updated_at,
          verified: oldSchoolUser.verified,
        },
      };
      if (successCallback) {
        successCallback(person);
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      } else {
        processUnexpectedError(error);
      }
    });
};
